module.exports = __webpack_public_path__ + "img/5.980c36e1.png";